import { get } from 'lodash'

import type { RootState } from '../../../store/types'
import type { CloudMarketplace } from '../../productsListing/types'

export const getSelectedCloudProvider = (
  getState: () => RootState
): CloudMarketplace =>
  get(
    getState(),
    'productListingFilters.cloudMarketplace',
    'AWS'
  ) as CloudMarketplace
